import { Location } from '@angular/common';
import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService } from '../auth.service';

export const authGuard = (): boolean | UrlTree => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const location = inject(Location);

  if (authService.isAuthenticated) {
    return true;
  }

  authService.setRedirectUrl(location.path());
  // Redirect to the login page
  return router.parseUrl('/auth');
};
